import { Link } from 'react-router-dom';

export function NotFoundPage() {
  return (
    <div className="page narrow-page">
      <section className="result-card">
        <span className="eyebrow">页面不存在</span>
        <h1>这个地址可能已经变化</h1>
        <p className="result-body">返回首页重新选择问题，不要在陌生页面输入账号或密码。</p>
        <Link className="primary-button" to="/">返回自助排查</Link>
      </section>
    </div>
  );
}
